import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContextoTenantStore } from '@/app/core/auth/contexto-tenant.store';
import { CatalogoReportesService } from '@/app/pages/reportes/core/catalogo-reportes.service';
import { AppMenuitem } from './app.menuitem';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        @for (item of model(); track item.label) {
            <li app-menuitem [item]="item" [root]="true"></li>
        }
    </ul>`
})
export class AppMenu {
    private readonly contexto = inject(ContextoTenantStore);
    private readonly catalogoReportes = inject(CatalogoReportesService);

    readonly model = computed(() => {
        const serviciosReportes = this.catalogoReportes.listarServicios().filter((servicio) => this.contexto.tienePermiso(servicio.datos.permiso));
        const items: any[] = [
            {
                label: 'Inicio',
                icon: 'pi pi-home',
                items: [
                    {
                        label: 'Inicio',
                        icon: 'pi pi-chart-bar',
                        routerLink: ['/']
                    },
                    this.contexto.tienePermiso('reportes.crear')
                        ? {
                              label: 'Reportes',
                              icon: 'pi pi-file',
                              routerLink: ['/reportes']
                          }
                        : null,
                    this.contexto.tienePermiso('reportes.crear')
                        ? {
                              label: 'Armar Reporte',
                              icon: 'pi pi-file-excel',
                              routerLink: ['/armar-reporte']
                          }
                        : null,
                    this.contexto.tienePermiso('reportes.crear')
                        ? {
                              label: 'Actualizar Datos',
                              icon: 'pi pi-bolt',
                              routerLink: ['/actualizar-reportes']
                          }
                        : null
                ].filter(Boolean)
            }
        ];

        if (['clientes.ver', 'clientes.asignarusuarios', 'clientes.asignargrupos'].some((permiso) => this.contexto.tienePermiso(permiso))) {
            items.push({
                label: 'Clientes',
                icon: 'pi pi-address-book',
                items: [
                    {
                        label: 'Clientes',
                        icon: 'pi pi-building',
                        routerLink: ['/clientes']
                    }
                ]
            });
        }

        if (serviciosReportes.length > 0) {
            items.push({
                label: 'Reportes',
                icon: 'pi pi-chart-line',
                items: [
                    ...serviciosReportes.map((servicio) => ({
                        label: servicio.datos.nombre,
                        icon: servicio.datos.icono ?? 'pi pi-file',
                        organismo: servicio.datos.codigo,
                        path: servicio.datos.ruta,
                        items: servicio
                            .listar()
                            .filter((reporte) => reporte.datos.visibleEnMenu !== false)
                            .map((reporte) => ({
                                label: reporte.datos.tituloMenu ?? reporte.datos.tituloReporte,
                                punto: true,
                                routerLink: [servicio.datos.ruta],
                                fragment: reporte.id
                            }))
                    }))
                ].filter(Boolean)
            });
        }

        // if (this.contexto.tienePermiso('tenant.ver')) {
        //     items.push({
        //         label: 'Reportes',
        //         icon: 'pi pi-chart-line',
        //         items: [
        //             {
        //                 label: 'SII',
        //                 icon: 'pi pi-file',
        //                 path: '/reporte/sii',
        //                 items: [
        //                     {
        //                         label: 'Datos Tributarios',
        //                         icon: 'pi pi-table',
        //                         routerLink: ['/reporte/sii/datos-tributarios']
        //                     },
        //                     {
        //                         label: 'F29',
        //                         icon: 'pi pi-table',
        //                         routerLink: ['/reporte/sii/reporte-f29']
        //                     },
        //                     {
        //                         label: 'F50',
        //                         icon: 'pi pi-table',
        //                         routerLink: ['/reporte/sii/reporte-f50']
        //                     },
        //                     {
        //                         label: 'F22',
        //                         icon: 'pi pi-table',
        //                         routerLink: ['/reporte/sii/reporte-f22']
        //                     },
        //                     {
        //                         label: 'Declaraciones Juradas',
        //                         icon: 'pi pi-table',
        //                         routerLink: ['/reporte/sii/declaraciones-juradas']
        //                     },
        //                     {
        //                         label: 'Giros y Multas',
        //                         icon: 'pi pi-table',
        //                         routerLink: ['/reporte/sii/multas']
        //                     },
        //                     {
        //                         label: 'Propiedades',
        //                         icon: 'pi pi-building',
        //                         routerLink: ['/reporte/sii/propiedades']
        //                     },
        //                     {
        //                         label: 'Deudas de Propiedades',
        //                         icon: 'pi pi-dollar',
        //                         routerLink: ['/reporte/sii/deudas-propiedades']
        //                     },
        //                     {
        //                         label: 'Devoluciones IVA',
        //                         icon: 'pi pi-dollar',
        //                         routerLink: ['/reporte/sii/devoluciones-iva']
        //                     },
        //                     {
        //                         label: 'Peticiones Administrativas',
        //                         icon: 'pi pi-inbox',
        //                         routerLink: ['/reporte/sii/peticiones-administrativas']
        //                     },
        //                     {
        //                         label: 'IVA Postergado',
        //                         icon: 'pi pi-calendar-clock',
        //                         routerLink: ['/reporte/sii/iva-postergado']
        //                     },
        //                     {
        //                         label: 'F29 Observado',
        //                         icon: 'pi pi-exclamation-circle',
        //                         routerLink: ['/reporte/sii/f29-observado']
        //                     },
        //                     {
        //                         label: 'Correo Inscrito',
        //                         icon: 'pi pi-envelope',
        //                         routerLink: ['/reporte/sii/correo-inscrito']
        //                     },
        //                     {
        //                         label: 'Agentes Retenedores',
        //                         icon: 'pi pi-file-check',
        //                         routerLink: ['/reporte/sii/agentes-retenedores']
        //                     },
        //                     {
        //                         label: 'Boletas Honorarios',
        //                         icon: 'pi pi-receipt',
        //                         routerLink: ['/reporte/sii/boletas-honorarios']
        //                     },
        //                     {
        //                         label: 'Registro Compras y Ventas',
        //                         icon: 'pi pi-book',
        //                         routerLink: ['/reporte/sii/registro-compras-ventas']
        //                     },
        //                     {
        //                         label: 'Comunicaciones SII',
        //                         icon: 'pi pi-bell',
        //                         routerLink: ['/reporte/sii/comunicaciones']
        //                     }
        //                 ]
        //             }
        //         ]
        //     });
        // }

        const administracion = [
            this.contexto.tienePermiso('usuarios.ver')
                ? {
                      label: 'Usuarios',
                      icon: 'pi pi-users',
                      routerLink: ['/administracion/usuarios']
                  }
                : null,

            this.contexto.tienePermiso('roles.ver')
                ? {
                      label: 'Roles y permisos',
                      icon: 'pi pi-shield',
                      routerLink: ['/administracion/roles']
                  }
                : null,

            this.contexto.tienePermiso('grupos.ver')
                ? {
                      label: 'Grupos',
                      icon: 'pi pi-sitemap',
                      routerLink: ['/administracion/grupos']
                  }
                : null,

            this.contexto.tienePermiso('auditoria.ver')
                ? {
                      label: 'Auditoría',
                      icon: 'pi pi-history',
                      routerLink: ['/administracion/auditoria']
                  }
                : null,

            this.contexto.tienePermiso('tenant.ver')
                ? {
                      label: 'Mi empresa',
                      icon: 'pi pi-building',
                      routerLink: ['/administracion/tenant']
                  }
                : null,

            this.contexto.tienePermiso('tenant.ver')
                ? {
                      label: 'Configuración',
                      icon: 'pi pi-cog',
                      routerLink: ['/administracion/configuracion']
                  }
                : null
        ].filter(Boolean);

        if (administracion.length) {
            items.push({
                label: 'Administración',
                icon: 'pi pi-cog',
                items: administracion
            });
        }

        if (this.contexto.administradorplataforma()) {
            items.push({
                label: 'Plataforma',
                icon: 'pi pi-globe',
                items: [
                    {
                        label: 'Empresas',
                        icon: 'pi pi-building-columns',
                        routerLink: ['/plataforma/tenants']
                    },
                    {
                        label: 'Catálogos de configuración',
                        icon: 'pi pi-sliders-h',
                        routerLink: ['/plataforma/catalogos-configuracion']
                    },
                    {
                        label: 'Planes',
                        icon: 'pi pi-tags',
                        routerLink: ['/plataforma/planes']
                    }
                ]
            });
        }

        return items;
    });
}
